import { useEffect, useRef } from 'react';
import { CloseIcon, NavigationCarat } from '../assets/svgImages';
import { MobileListItem, SubMenuProps } from '../interface/interface';
import { PROFILE_LIST } from '../constant/constant';

const SubMenu = ({
  mobileMenuOpen,
  onMobileMenuClose,
  isMobile = false,
}: SubMenuProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const closeMobileDrawer = () => {
    onMobileMenuClose();
  };

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const userNavigation = (isMobile: boolean) => {
    if (isMobile) {
      const updated = [...PROFILE_LIST];
      updated.splice(1, 0, { name: 'Inbox', href: '/notification-inbox' });
      return updated;
    }
    return PROFILE_LIST;
  };

  return (
    <div
      ref={menuRef}
      className="bg-white shadow-xl md:p-3 relative flex items-center justify-center"
    >
      {mobileMenuOpen && (
        <div
          className={`md:hidden absolute left-0 w-full z-50 bg-white shadow-xl border-t border-gray-100 flex flex-col h-[100vh] top-0 z-[900]`}
        >
          <div className="flex items-center justify-end px-4 py-3 shrink-0">
            <CloseIcon
              onClick={closeMobileDrawer}
              className="cursor-pointer fill-primary-blue-500 sm:w-4 sm:h-4"
            />
          </div>

          <div className="flex-1 overflow-y-auto">
            <MobileList
              items={userNavigation(isMobile).map((list) => ({
                key: list.name!,
                label: list.name!,
                onClick: () => window.location.replace(list.href!),
                hidden: false,
              }))}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const MobileList = ({ items }: { items: MobileListItem[] }) => {
  const filteredMenu = items?.filter((item) => item.hidden == false);
  return (
    <div className="flex flex-col divide-y divide-grey-200">
      {filteredMenu?.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={item.onClick}
          className="flex items-center justify-between px-4 py-5 text-sm font-semibold text-left text-black"
        >
          {item.label}
          {item.hasChildren && (
            <NavigationCarat className="w-3.5 h-3.5 text-gray-400" />
          )}
        </button>
      ))}
    </div>
  );
};

export default SubMenu;
